/* import 'aos/dist/aos.css'; */
import './scss/style.scss';
import './js/index';